<div class="modal-content page-publish-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'smsadv_list_details_modal_title' | translate }}</h5>
    <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" (click)="dismiss.emit()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex align-items-center">
      <span>
        <img class="icon-recipient-custom" src="assets/images/icons/icon-recipients.svg" />
      </span>
      <h5 class="modal-title ms-2">{{ 'mail_recipients' | translate }}</h5>
    </div>
    <!-- gender -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_create_gender' | translate }}:</span>
      <span class="font-weight-bold p-2" translate>{{ genders }}</span>
    </div>
    <!-- Age ranges  -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_create_age' | translate }}</span>
      <span class="font-weight-bold p-2">{{ ageRanges }}</span>
    </div>
    <!-- Area Geographics -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_recipients_area' | translate }}</span>
      <span *ngIf="isRegions" class="font-weight-bold p-2"
        >{{ 'smsadv_summary_settings_recipients_area_regions' | translate }} {{ regionValue }}</span
      >
      <span *ngIf="isProvinces" class="font-weight-bold p-2"
        >{{ 'smsadv_summary_settings_recipients_area_provinces' | translate }} {{ provincesValue }}</span
      >
      <span *ngIf="isZipCodes" class="font-weight-bold p-2"
        >{{ 'smsadv_summary_settings_recipients_area_zip_codes' | translate }} {{ zipCodesValue }}</span
      >
    </div>
    <!-- Recipients Available  -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_recipients_number_available' | translate }}</span>
      <span class="font-weight-bold p-2">{{ recipientsAvailable }}</span>
    </div>
    <!-- separator line -->
    <div class="p-4"></div>
    <!--Campaign -->
    <div class="d-flex align-items-center">
      <span>
        <img class="icon-campaign-custom" src="assets/images/icons/summary-campaign.png" />
      </span>
      <h5 class="modal-title ms-2">{{ 'smsadv_summary_campaign' | translate }}</h5>
    </div>
    <!-- Title -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_config_title' | translate }}</span>
      <span class="font-weight-bold p-2">{{ smsAdvItemsDetail?.title }}</span>
    </div>
    <!-- Text -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_config_text' | translate }}</span>
      <span class="text-break font-weight-bold p-2">{{ smsAdvItemsDetail?.message }}</span>
    </div>
    <!-- Sender -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_config_sender' | translate }}</span>
      <span class="font-weight-bold p-2">{{ smsAdvItemsDetail?.sender?.valueSender }}</span>
    </div>
    <!-- Schedule date -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_config_sender' | translate }}</span>
      <span class="font-weight-bold p-2">{{ sendingDate }}</span>
    </div>
    <!-- Recipients -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_recipients_number' | translate }}</span>
      <span class="font-weight-bold p-2">{{ recipientsAvailable }}</span>
    </div>
    <!-- Fragmants -->
    <div class="my-2 m-2">
      <span>{{ 'smsadv_summary_settings_messages_number' | translate }}:</span>
      <span class="font-weight-bold p-2">{{ smsAdvItemsDetail?.fragmentsCount }}</span>
    </div>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="dismiss.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
  </div>
</div>
